/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicDiskUtilization extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicDiskUtilization");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicDiskUtilization.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicDiskUtilization>): BackgroundJobPayloadForPeriodicDiskUtilization {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicDiskUtilization(), model);
        BackgroundJobPayloadForPeriodicDiskUtilization.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicDiskUtilization>): BackgroundJobPayloadForPeriodicDiskUtilization {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicDiskUtilization.newInstance(<BackgroundJobPayloadForPeriodicDiskUtilization> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicDiskUtilization) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicDiskUtilization.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicDiskUtilization): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicDiskUtilization.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
